// extracted by mini-css-extract-plugin
export default {"title":"DiplomaSuccess_title__Bj-Do"};